/**
 * Constants for the OneHR Contract Add-in
 */

export const DEFAULT_API_KEY =
  "784e94dae7b42c27-7bfeaff15ecc1366-9b414877580a4541-bc1654c2f0199bda";

export const CATEGORY_LABELS: Record<string, string> = {
  personal: "Хувь хүний мэдээлэл",
  job: "Ажлын мэдээлэл",
  salary: "Цалингийн мэдээлэл",
  company: "Байгууллагын мэдээлэл",
  contract: "Гэрээний мэдээлэл",
  decree: "Тушаалын мэдээлэл",
  request: "Хүсэлтийн мэдээлэл",
  system: "Системийн талбарууд",
};

export const VALID_DATE_FORMATS = [
  "default",
  "YYYY.MM.DD",
  "YYYY/MM/DD",
  "YYYY-MM-DD",
  "DD.MM.YYYY",
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  "MM/DD/YYYY",
  "ll",
  "LL",
  "LL-long",
] as const;

export const VALID_NUMBER_FORMATS = [
  "default",
  "formatted",
  "mongolian",
  "mongolian_currency",
] as const;

export const DATE_FORMAT_EXAMPLES: Record<string, string> = {
  "YYYY.MM.DD": "2024.01.15",
  "YYYY/MM/DD": "2024/01/15",
  "YYYY-MM-DD": "2024-01-15",
  "DD.MM.YYYY": "15.01.2024",
  "DD/MM/YYYY": "15/01/2024",
  "DD-MM-YYYY": "15-01-2024",
  "MM/DD/YYYY": "01/15/2024",
  ll: "2024 оны 01 сарын 15",
  LL: "2024 оны 1 дүгээр сарын 15",
  "LL-long": "хоёр мянган хорин дөрөвдүгээр оны нэгдүгээр сарын арван тавны өдөр",
};

export const NUMBER_FORMAT_EXAMPLES: Record<string, { label: string; example: string }> = {
  default: { label: "Анхдагч (форматгүй)", example: "1500000" },
  formatted: { label: "Тоогоор (таслалтай)", example: "1,500,000" },
  mongolian: { label: "Монгол үсгээр", example: "нэг сая таван зуун мянга" },
  mongolian_currency: {
    label: "Монгол үсгээр (төгрөг)",
    example: "нэг сая таван зуун мянган төгрөг",
  },
};

export const PARTICIPANT_TYPE_LABELS: Record<string, string> = {
  EMPLOYEE: "Хувь хүн",
  ORGANIZATION: "Байгууллага",
};

export const DOCUMENT_TYPE_LABELS: Record<string, string> = {
  contract: "Гэрээ",
  decree: "Тушаал",
  "job-description": "Албан тушаалын тодорхойлолт",
};

export const VALIDATION_MESSAGES = {
  NO_TEMPLATE: "Загвар ачаалаагүй байна. Эхлээд загварыг холбоно уу.",
  EMPTY_KEY: "Алдаа: Түлхүүр хоосон байна",
  INVALID_KEY_FORMAT: "Алдаа: Түлхүүрийн нэр буруу байна",
  INVALID_FORMAT: "Алдаа: Буруу формат",
  SYNTAX_ERROR: "Алдаа: Буруу синтакс",
  VALIDATION_SUCCESS: "✅ Бүх түлхүүрүүд зөв байна!",
  VALIDATION_FAILED: "Баталгаажуулалт амжилтгүй",
  SAVE_SUCCESS: "Загвар амжилттай хадгалагдлаа!",
  SAVE_FAILED: "Хадгалалт амжилтгүй",
} as const;

export const STATUS_MESSAGES = {
  LOADING_TEMPLATE: "Загвар ачаалж байна...",
  VALIDATING: "Түлхүүрүүдийг шалгаж байна...",
  SAVING: "Загвар хадгалж байна...",
  READY_TO_VALIDATE: "Баталгаажуулах эсвэл хадгалахад бэлэн.",
  READY_TO_SAVE: "Дахин загвар хадгалахад бэлэн.",
  NO_TEMPLATE_CODE: "Загварын код оруулна уу.",
} as const;

export const ZERO_WIDTH_SPACE = "\u200B";

export const PLACEHOLDER_REGEX = {
  VALID_PATTERN: /^\{\{[^}|]+(\|[^}]+)?\}\}$/,
  VALID_KEY: /^[a-zA-Z_$][a-zA-Z0-9_$.]*(\.[a-zA-Z0-9_$.]+)*$/,
  EXTRACT_PLACEHOLDERS: /\{\{[^}]+\}\}/g,
} as const;
